import React from "react";
import "../printStyles.css";

function LicenceAndDocumentsValidityCheck() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #LicenceAndDocumentsValidityCheckForm, #LicenceAndDocumentsValidityCheckForm * {
              visibility: visible;
            }
            #LicenceAndDocumentsValidityCheckForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="LicenceAndDocumentsValidityCheckForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Licence & Documents Validity Check</h3>

        <form>
          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Date of Check */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="dateOfCheck">
              Date of Check:
            </label>
            <input
              type="date"
              id="dateOfCheck"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Document Checkboxes */}
          <div className="mb-4">
            <h5 className="text-lg font-medium mb-2 text-gray-700">Documents:</h5>
            <div className="space-y-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Road Tax</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">MOT / Annual Test</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">O-Licence</span>
              </label>
            </div>
          </div>

          {/* Validity Check */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="validUntil">
              Valid Until:
            </label>
            <input
              type="date"
              id="validUntil"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Status */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="status">
              Checked:
            </label>
            <div className="flex space-x-4 mt-2">
              <label className="flex items-center space-x-1">
                <input type="radio" name="status" value="Yes" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="status" value="No" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>

          {/* Overall Status */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="overallStatus">
              Overall Status:
            </label>
            <div className="flex space-x-4 mt-2">
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallStatus" value="AllValid" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">All Valid</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallStatus" value="ActionRequired" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Action Required</span>
              </label>
            </div>
          </div>

          {/* Notes */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record expiry dates or issues here..."
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default LicenceAndDocumentsValidityCheck;

